import type { Org } from "@/api/orgs"
import type { User } from "@/api/users"

export function loadIntercom(user: User, org: Org) {
  if (typeof Intercom !== "undefined") {
    Intercom("boot", {
      app_id: "jwmgbua5",
      email: user.email,
      created_at: user.createdAt as unknown as number,
      name: user.name,
      user_id: String(user.id),
      company: {
        company_id: org.subdomain,
        name: org.name,
        is_self_serve: org.isSelfServe,
      },
    })
  }
}

export function showNewIntercomMessage(message?: string): boolean {
  if (typeof Intercom !== "undefined") {
    Intercom("showNewMessage", message)
    return true
  } else {
    return false
  }
}
